import React,{useRef} from 'react';
import {Box, Typography,Button, Stack , Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Divider} from '@mui/material';
import { useLocation } from 'react-router-dom';
import image from "../../../asserts/logo logistic.png"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import DrsPdf from '../../../components/Custom/Drspdf';
import {fetchAndOpenDrsPdf} from "../../../redux/Thunk/drsThunk"
import { useDispatch } from "react-redux";
const Drspdf = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const drsData = location.state?.docketData;
  const drsPdfRef = useRef();
  const navigate=useNavigate();
  if (!drsData) {
    return <Typography variant="h6" color="error">No DRS data available</Typography>;
  }
     const handleDownloadClick = () => {
    dispatch(fetchAndOpenDrsPdf({DrsId:drsData?.DRSId}));
  };
    
  return (
    <>
    <Paper sx={{ p: 2, m: 2, fontSize: '12px' }} elevation={3}>
          <Stack direction={'row'} spacing={1} justifyContent={"flex-end"} alignItems={'center'}>
                  <Button sx={{justifyContent:'flex-end'}} variant="contained" color="success" onClick={handleDownloadClick}>Download PDF</Button>
                  </Stack>
     <Box sx={{ mr: 2 ,alignItems:"left"}}> <ArrowBackIcon onClick={() => navigate("/dashboard/drslist")}/></Box>
      <Box textAlign="center">
    
          <img src={image} alt='' style={{ height: 40 }} />
        <Typography variant="h6" fontSize="20px" fontWeight="bold" >
          LA LOGISTICS PRIVATE LIMITED
        </Typography>
        <Typography fontSize="11px">
          {/* E-44, OKHLA INDUSTRIAL ESTATE, Okhla Industrial Estate Phase 2, New Delhi */}
        </Typography>
        {/* <Typography fontSize="11px">New Delhi - 110022</Typography> */}
      </Box>

      <Box display="flex" justifyContent="space-between" mt={2} mb={1}>
        <Box>
          <Typography fontSize="15px"><strong>Delivery Boy : </strong>{drsData?.DeliveryBoy?.[0]?.AdminName}</Typography>
          <Typography fontSize="15px"><strong>Mobile : </strong>{drsData?.DeliveryBoy?.[0]?.Mobile}</Typography>
        </Box>
        <Box>
          <Typography fontSize="15px"><strong>Branch : </strong>{drsData?.Branch?.OfficeName}</Typography>
          <Typography fontSize="15px"><strong>Area : </strong> {drsData?.Branch?.Address}</Typography>
          {/* <Typography fontSize="15px">Manual ID: 0</Typography> */}
        </Box>
        <Box textAlign="right">
          <Typography fontSize="15px"><strong>DRS NO :</strong> {drsData?.DRSId}</Typography>
          <Typography fontSize="15px"><strong>DRS Date : </strong>{new Date(drsData?.Date).toLocaleDateString()}</Typography>
          <Typography fontSize="15px"><strong>Vehicle No : </strong>{drsData?.VehicleNo}</Typography>
        </Box>
      </Box>

      <TableContainer>
        <Table size="small" sx={{ border: '1px solid black' }}>
          <TableHead>
            <TableRow sx={{ background: '#f0f0f0' }}>
              <TableCell sx={{fontWeight:"700"}}>SN</TableCell>
              <TableCell sx={{fontWeight:"700"}}>Docket Number</TableCell>
              <TableCell sx={{fontWeight:"700"}}>Delivery Address</TableCell>
              <TableCell sx={{fontWeight:"700"}}>Delivery Contact Number</TableCell>
              <TableCell sx={{fontWeight:"700"}}>Customer Name</TableCell>
              <TableCell sx={{fontWeight:"700"}}>Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {drsData?.PickupDetails?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item?.DocketId || '--'}</TableCell>
                <TableCell>{item?.Destination || '--'}</TableCell>
                <TableCell>{item?.ConsigneeMobile || item?.Mobile || '--'}</TableCell>
                <TableCell>{item?.ConsigneeName || item?.Consignee || '--'}</TableCell>
                <TableCell>{drsData?.Date ? `${new Date(drsData.Date).toLocaleDateString()} ${drsData?.Time || ''}` : '--'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="space-between" mt={2}>
        <Typography fontSize="14px"><strong>Total AWB No. : </strong>{drsData?.PickupDetails?.length}</Typography>
        <Typography fontSize="14px"><strong>Total Box : </strong>{drsData?.PickupDetails?.length}</Typography>
      </Box>

      <Divider sx={{ my: 1 }} />

      <Box display="flex" justifyContent="space-between">
        <Typography fontSize="14px"><strong>User : </strong>{drsData?.Branch?.AdminName || 'N/A'}</Typography>
        <Typography fontSize="14px"><strong>Check By :________________________</strong></Typography>
      </Box>
    </Paper>
    {/* <DrsPdf ref={drsPdfRef} drsData={drsData} /> */}
    </>
  );
};

export default Drspdf;
